import { Point } from "@/lib/math"

export class LineSegmentRuler {

    /**
     * @param {Point[]} points
     * @return {Array<{segment: [Point, Point], segmentIndexes: [number, number], distance: number}>}
     */
    static measureSegmentsFromPointList(points) {
        let pointObjects = points.map(point => Point.fromObject(point))
        let segments = []

        for (let i = 0; i < pointObjects.length; i++) {
            for (let j = i + 1; j < pointObjects.length; j++) {
                const p1 = pointObjects[i];
                const p2 = pointObjects[j];
                const distance = p1.distanceFrom(p2);

                segments.push({
                    segment: [p1, p2],
                    segmentIndexes: [i, j],
                    distance: distance
                })
            }
        }
        return segments;
    }

    /**
     * @param {Point[]} points
     * @returns {{segment: [Point, Point], segmentIndexes: [number, number], distance: number}}
     */
    static getFarthestSegmentFromPointList(points) {
        return LineSegmentRuler.measureSegmentsFromPointList(points)
            .sort((a, b) => b.distance - a.distance)
            .at(0)
    }
}